export const textColor = "text-gray-800 dark:text-gray-200";
export const textSize = "text-xs xl:text-sm";
export const panelTitleText = "text-md xl:text-lg font-bold";
export const backgroundColor = "bg-white dark:bg-gray-800";

export const buttonGrid = `bg-blue-500 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-1 xl:py-1 px-2 rounded ${textSize} flex items-center justify-center cursor-pointer disabled:cursor-not-allowed select-none`;
export const button = `bg-blue-500 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded ${textSize} flex items-center justify-center cursor-pointer disabled:cursor-not-allowed select-none`;
export const buttonAlert = `bg-red-500 hover:bg-red-400 disabled:bg-red-200 text-white font-bold py-2 px-4 rounded ${textSize} flex items-center justify-center cursor-pointer disabled:cursor-not-allowed select-none`;


export function getComplianceStyleClass(compliance: 'strict' | 'loose' | 'non-compliant'): string {
    switch (compliance) {
        case 'strict':
            return 'border-2 border-green-500 focus:border-green-500';
        case 'non-compliant':
            return 'border-4 border-red-500 focus:border-red-500';
        default:
            return '';
    }
}
